module.exports = __webpack_public_path__ + "img/novo.b0e42471.png";